import { Item } from '@react-stately/collections'
import Styles from './DesignFormatSelector.module.scss'
import { useLabel } from '@react-aria/label'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ASPECT_RATIOS, AspectRatioKey } from './Types'
import { Select } from 'components/Select/Select'

interface Props {
  value: AspectRatioKey
  onChange: (aspectRatio: AspectRatioKey) => void
}

export const DesignFormatSelector = ({ value, onChange }: Props) => {
  const { labelProps, fieldProps } = useLabel({ label: 'Format' })
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.designFormatSelector}>
      {isMobile ? (
        <Text variant="smallList">Format</Text>
      ) : (
        <Heading level={5} {...labelProps}>
          Format
        </Heading>
      )}
      <div className={Styles.field}>
        <Select
          {...fieldProps}
          variant="secondary"
          aria-labelledby={labelProps.id}
          size="lg"
          popoverClass={Styles.popover}
          selectedKey={value ?? 'instagram-square-post'}
          onSelectionChange={(key) => {
            const selected = ASPECT_RATIOS[key as AspectRatioKey]
            if (!selected) return
            onChange(key as AspectRatioKey)
          }}
          items={Object.entries(ASPECT_RATIOS)}
        >
          {Object.entries(ASPECT_RATIOS).map(([key, item]) => {
            const text = `${item.name} (${item.width}x${item.height})`
            return (
              <Item key={key} textValue={text}>
                {text}
              </Item>
            )
          })}
        </Select>
      </div>
    </div>
  )
}
